import { app } from '../../app.module'
app
  // 投稿テーブルページネーション
  .directive('postTablePagination', () => {
    return {
      restrict: 'E',
      template: require('./post-table-pagination.pug')(),
    }
  })
